import React from "react";
import {
  CalendarOutlined,
  DollarOutlined,
  DoubleRightOutlined,
} from "@ant-design/icons";
import { InputNumber, Tooltip } from "antd";
import { IoLayersOutline } from "react-icons/io5";
import { RiErrorWarningLine } from "react-icons/ri";

import * as S from "./styles";

import DSButton from "../../../../../components/DSButton";
import { TSelectedSale } from "./types";
import designSystemColors from "../../../../../styles";

const SelectedSale: React.FC<TSelectedSale> = ({
  selectedSaleData,
  antecipateTotal,
  antecipatePartial,
  formatDate,
  installmentsValue,
  onInstallmentsChange,
}) => {
  const maxInstallments = selectedSaleData.numeroParcelasAntecipaveis;
  return (
    <S.DetailCard>
      <S.DetailHeader>
        <S.TextId># VND-{selectedSaleData.idCompra}</S.TextId>
        <S.TextStore>{selectedSaleData.nomeEstabelecimento}</S.TextStore>
      </S.DetailHeader>
      <S.DetailContent>
        <S.InfoGrid>
          <S.InfoItem>
            <S.ItemLabel>
              <CalendarOutlined className="highlight" /> Data da Compra
            </S.ItemLabel>
            <S.ItemText>{formatDate(selectedSaleData.dataCompra)}</S.ItemText>
          </S.InfoItem>
          <S.InfoItem>
            <S.ItemLabel>
              <DollarOutlined className="highlight" /> Valor Total
            </S.ItemLabel>
            <S.ItemText>{selectedSaleData?.valorTotalCompra}</S.ItemText>
          </S.InfoItem>
          <S.InfoItem>
            <S.ItemLabel>
              <DollarOutlined className="highlight" /> Valor da Parcela
            </S.ItemLabel>
            <S.ItemText>R$ {selectedSaleData?.valorParcela}</S.ItemText>
          </S.InfoItem>
          <S.InfoItem>
            <S.ItemLabel>
              <IoLayersOutline className="highlight" /> Total de Parcelas
            </S.ItemLabel>
            <S.ItemText>{selectedSaleData.numeroParcelas}</S.ItemText>
          </S.InfoItem>
          <S.InfoItem>
            <S.ItemLabel>
              <DoubleRightOutlined className="highlight" /> Parcelas a Antecipar
            </S.ItemLabel>
            <S.ItemText className="highlight">
              {selectedSaleData.numeroParcelasAntecipaveis}
            </S.ItemText>
          </S.InfoItem>
        </S.InfoGrid>

        <S.Wrapper>
          <S.InstallmentsDescription
            style={{ fontWeight: "bold", fontSize: "14px" }}
          >
            Quantidade de parcelas a antecipar
          </S.InstallmentsDescription>
          <Tooltip
            title="A antecipação de parcelas funciona sempre da última parcela disponível para a primeira. Sendo o máximo possível a quantidade de parcelas a antecipar"
            data-test-id="tooltip-descrição-parcelas"
          >
            <RiErrorWarningLine
              style={{
                color: designSystemColors.generalButtons,
                cursor: "pointer",
              }}
              size={20}
            />
          </Tooltip>
        </S.Wrapper>
        <S.ActionRow>
          <InputNumber
            data-test-id="input-parcelas"
            min={1}
            max={maxInstallments}
            value={installmentsValue}
            onChange={(val) => onInstallmentsChange(val || 1)}
            placeholder={`1 a ${maxInstallments}`}
            style={{ width: 200, borderRadius: 8 }}
          />
          <div style={{ flex: 1 }} />
          <DSButton
            dataTestId="btn-antecipar-parcial"
            style={{
              height: 40,
              padding: "16px 8px",
              fontWeight: "bold",
            }}
            buttonType="primary"
            buttonText="Antecipar Parcelas"
            onClick={antecipatePartial}
          />

          <DSButton
            dataTestId="btn-antecipar-total"
            style={{
              height: 40,
              padding: "16px 8px",
            }}
            isIconAfter={false}
            buttonType="secondary"
            isCancelType
            buttonText="Antecipar Todas"
            onClick={antecipateTotal}
          />
        </S.ActionRow>
      </S.DetailContent>
    </S.DetailCard>
  );
};

export default SelectedSale;
